import emailjs from "@emailjs/browser";

// e is any form data
const sendEmail = (formRef) => {
    emailjs
        .sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            formRef.current,
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        )
        .then(
            (result) => {
                console.log(result.text);
                alert("Message sent successfully!");
                if (formRef.current) {
                    formRef.current.reset(); // Clear the form after success
                }
            },
            (error) => {
                console.log("Error sending message:", error.text);
                alert("Failed to send the message. Please try again.");
            }
        );
};

export { sendEmail };